export function binary_search_iterative(a, value) {
  var lo = 0,
    hi = a.length - 1,
    mid;
  while (lo <= hi) {
    mid = Math.floor((lo + hi) / 2);
    if (a[mid].fValue > value) hi = mid - 1;
    else if (a[mid].fValue < value) lo = mid + 1;
    else {
      if (a[mid].fValue == value) return mid;
      else return null;
    }
  }
  return null;
}
